<template>
  <div>
    <div v-if="!isManageable">
      {{ data.name }}
    </div>
    <div v-else>
      {{ data.name + ' - ' }}
      <a
        v-if="isGroup() && ((isTestGroup && emailTesting.canModifyTestList) || (isGlobalGroup && emailTesting.canModifyGlobalList))"
        href=""
        @click="onAddClick"
      >
        Add
      </a>
      <a
        v-else-if="(isTestGroup && emailTesting.canModifyTestList) || (isGlobalGroup && emailTesting.canModifyGlobalList)"
        href=""
        @click="onManageClick"
      >
        Manage
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    getSendTestRefs: Function
  },
  data () {
    return {
      data: {}
    }
  },
  computed: {
    ...mapGetters({
      emailTesting: 'getEmailTesting'
    }),
    isManageable () {
      const allowedGroups = ['test', 'global']
      const id = this.data.id.toLowerCase()
      const pid = this.data.pid ? this.data.pid.toLowerCase() : ''
      return allowedGroups.includes(id) || allowedGroups.includes(pid)
    },
    isTestGroup () {
      const id = this.data.id.toLowerCase()
      const pid = this.data.pid ? this.data.pid.toLowerCase() : ''
      return [id, pid].includes('test')
    },
    isGlobalGroup () {
      const id = this.data.id.toLowerCase()
      const pid = this.data.pid ? this.data.pid.toLowerCase() : ''
      return [id, pid].includes('global')
    }
  },
  methods: {
    isGroup () {
      return 'hasChild' in this.data
    },
    onAddClick (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$store.commit('SET_EMAIL_TESTING_ON_EDITION', {
        listTitle: this.data.name,
        seedListType: this.data.id
      })
      this.emailTesting.manageModalRef.openDialog()
    },
    onManageClick (e) {
      e.preventDefault()
      e.stopPropagation()
      this.emailTesting.manageModalRef.openDialog()
      const emailTestingOnEdition = this.emailTesting.emailList.find(item => {
        return item.id === this.data.id && item.pid === this.data.pid
      })
      if (emailTestingOnEdition) {
        this.$store.commit('SET_EMAIL_TESTING_ON_EDITION', emailTestingOnEdition)
      }
    }
  }
}
</script>

<style>

</style>
